/**
 * 一般廃棄物処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

import {
  DRIVER_GENERAL_WASTE_DISPOSAL_CONDITION,
  DRIVER_GENERAL_WASTE_DISPOSAL_PAGINATION,
  DRIVER_GENERAL_WASTE_DISPOSAL_RESET_PAGINATION,
  DRIVER_GENERAL_WASTE_DISPOSAL_RESET_CONDITION,
} from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/general_waste_disposals`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      code: null,
      name: null,
      location_code: null,
      location_name: null,
      unregister_location: false,
    },
  }
}
const driver_master_general_waste_disposal = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 一覧情報の取得を行う.
     * リクエスト前に検索条件をローカルストレージに保存.
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { object } 検索条件
     * @property conditions.code { string } 事業者コード
     * @property conditions.name { string } 事業者名
     * @property conditions.location_code { string } 事業場コード
     * @property conditions.location_name { string } 事業場名
     * @property conditions.unregister_location { boolean } 事業場警告
     * @property conditions.page { number } ページ番号
     * @property conditions.limit { number } 一覧表示件数
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions }) {
      let api_path = API_PATH
      if (conditions.format === 'csv') {
        api_path = `${API_PATH}.csv`
      }
      dispatch('saveCondition',
        {
          conditions: conditions,
        }
      )
      const params = {
        code: state.condition.code,
        name: state.condition.name,
        location_code: state.condition.location_code,
        location_name: state.condition.location_name,
        unregister_location: state.condition.unregister_location,
        limit: conditions.limit,
        page: conditions.page

      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (conditions.format === 'csv') {
            resolve(data)
          } else {
            const content = data.content
            commit(DRIVER_GENERAL_WASTE_DISPOSAL_PAGINATION, { content })
            resolve(content)
          }
        })
      })
    },
    /**
     * 詳細情報の取得.
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 新規初期情報の取得.
     * @returns {Promise<unknown>}
     */
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 登録排出事業者のテナント内の件数取得
     * お試しプランの件数チェック用に検索条件を無視して件数を取得する
     * @param commit
     * @return {Promise<unknown>}
     */
    check ({ commit }) {
      const params = {}
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 検索条件の保持を行う.
     * @param commit
     * @param state
     * @param conditions { object } 検索有情拳
     * @param limit { number } 一覧表示件数
     */
    saveCondition ({ commit, state }, { conditions }) {
      const _code = (conditions?.code !== undefined) ? conditions.code : state.condition.code
      const _name = (conditions?.name !== undefined) ? conditions.name : state.condition.name
      const _location_code = (conditions?.location_code !== undefined) ? conditions.location_code : state.condition.location_code
      const _location_name = (conditions?.location_name !== undefined) ? conditions.location_name : state.condition.location_name
      const _unregister_location = (conditions?.unregister_location !== undefined ? conditions.unregister_location : state.condition.unregister_location)
      const _limit = (conditions?.limit !== undefined) ? conditions.limit : state.condition.limit
      const params = {
        code: _code,
        name: _name,
        location_code: _location_code,
        location_name: _location_name,
        unregister_location: _unregister_location,
        limit: _limit
      }
      commit(DRIVER_GENERAL_WASTE_DISPOSAL_CONDITION, { params })
    },
    /**
     * 保持している検索条件を破棄する.
     * @param commit
     */
    resetState({ commit }) {
      commit(DRIVER_GENERAL_WASTE_DISPOSAL_RESET_CONDITION)
    },
    /**
     * 保持している検索条件を破棄する.
     * @param commit
     */
    resetPagination ({ commit }) {
      commit(DRIVER_GENERAL_WASTE_DISPOSAL_RESET_PAGINATION)
    },
  },
  mutations: {
    /**
     * 保持している検索条件を破棄する
     * @param state
     */
    [DRIVER_GENERAL_WASTE_DISPOSAL_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * 保持しているページング情報を破棄する
     * @param state
     */
    [DRIVER_GENERAL_WASTE_DISPOSAL_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    /**
     * ページング情報の保持
     * @param state
     * @param content
     */
    [DRIVER_GENERAL_WASTE_DISPOSAL_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    /**
     * 検索条件の保持
     * @param state
     * @param params
     */
    [DRIVER_GENERAL_WASTE_DISPOSAL_CONDITION] (state, { params }) {
      state.condition.code = params.code
      state.condition.name = params.name
      state.condition.location_code = params.location_code
      state.condition.location_name = params.location_name
      state.condition.unregister_location = params.unregister_location
      state.condition.limit = params.limit
    }
  },
}

export default driver_master_general_waste_disposal
